// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import { getOverallDashboardApi } from "../../apis/dashboardApi";

// export const useOverallDashboard = () => {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchDashboardData = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const data = await getOverallDashboardApi();
//       setDashboardData(data);

//       // Optional: keep success toast (many teams remove it on dashboard load)
//       // toast.success("Dashboard loaded", { autoClose: 2200 });

//       return data;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to load dashboard data. Please try again later.";

//       toast.error(errorMessage, {
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       console.error("Error fetching dashboard data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   return { dashboardData, loading, error, fetchDashboardData };
// };

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getOverallDashboardApi } from "../../apis/dashboardApi";

export const useOverallDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    const res = err.response?.data;

    return {
      title: res?.message || "Dashboard Error",
      issue:
        res?.data ||
        err.message ||
        "Failed to load dashboard data. Please try again later.",
    };
  };

  const fetchDashboardData = async () => {
    setLoading(true);
    setError(null);
   try {
      const data = await getOverallDashboardApi();
      setDashboardData(data);

      // Optional: keep success toast (many teams remove it on dashboard load)
      // toast.success("Dashboard loaded", { autoClose: 2200 });

      return data;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.error(
        <div>
          <strong>{title}</strong>
          <div>{issue}</div>
        </div>,
        { autoClose: 5000 }
      );

      setError({ title, issue });
      console.error("Error fetching dashboard data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  return { dashboardData, loading, error, fetchDashboardData };
};